import './App.css'
import Pages from "@/pages/index.jsx"
import { Toaster } from "@/components/ui/toaster"
import { AuthProvider } from "@/hooks/useAuth.jsx"
import { UniversityProvider } from "@/hooks/useUniversity.jsx"
import ErrorBoundary from "@/components/ErrorBoundary.jsx"
import { setupGlobalErrorHandling } from "@/lib/monitoring"
import { setupFocusVisible } from "@/lib/accessibility"
import { useEffect } from 'react'

function App() {
  useEffect(() => {
    // Initialize global error handling
    setupGlobalErrorHandling();
    
    // Initialize accessibility features
    setupFocusVisible();
    
    // Performance monitoring
    if (import.meta.env.PROD) {
      // Monitor Core Web Vitals in production
      import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
        getCLS(console.log);
        getFID(console.log);
        getFCP(console.log);
        getLCP(console.log);
        getTTFB(console.log);
      });
    }
  }, []);

  return (
    <ErrorBoundary>
      <AuthProvider>
        <UniversityProvider>
          <Pages />
          <Toaster />
        </UniversityProvider>
      </AuthProvider>
    </ErrorBoundary>
  )
}

export default App 